import React from "react";
import { Link } from "react-router-dom";
import { Eye, X, Rocket } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

/**
 * DemoBanner — sticky bar shown at the top of every page for demo users.
 * Now includes a prominent "Join the Waitlist" CTA to close the loop for
 * prospects who like what they're seeing.
 */
export default function DemoBanner() {
  const { user, logout } = useAuth();
  if (!user || !user.is_demo) return null;

  const fireEvent = (kind) => {
    // fire-and-forget — never block navigation
    try { api.post("/demo/event", { kind }); } catch (_) { /* noop */ }
  };

  const exitDemo = async () => {
    fireEvent("demo_exited");
    try { await logout(); } catch (e) { /* no-op */ }
    window.location.href = "/";
  };

  const joinWaitlist = async () => {
    fireEvent("demo_clicked_join_waitlist");
    try { await logout(); } catch (e) { /* no-op */ }
    window.location.href = "/#join";
  };

  return (
    <div
      className="w-full sticky top-0 z-[60]"
      style={{ background: "#7A3A0B", color: "#FFF6EF" }}
      data-testid="demo-banner"
    >
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 py-2 px-3 text-[12px] sm:text-[13px] font-semibold tracking-wide text-center">
        <span className="inline-flex items-center gap-2">
          <Eye size={14} weight="fill" style={{ color: "#FFB073" }} />
          <span>You&apos;re in <strong>demo mode</strong> — data here is fake.</span>
        </span>
        <button
          onClick={joinWaitlist}
          className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full font-bold transition-transform hover:-translate-y-0.5"
          style={{ background: "#E26D29", color: "#fff" }}
          data-testid="demo-join-waitlist-btn"
        >
          <Rocket size={12} weight="fill" /> Join the waitlist
        </button>
        <button
          onClick={exitDemo}
          className="inline-flex items-center gap-1 underline underline-offset-2 hover:text-white opacity-90"
          data-testid="demo-exit-btn"
        >
          <X size={12} weight="bold" /> Exit demo
        </button>
      </div>
    </div>
  );
}
